import useCreateFreeTrialEnrollment from './useCreateFreeTrialEnrollment';

export default useCreateFreeTrialEnrollment;
